import { Component, Input } from '@angular/core';

import { SlipState } from '@bpos/v1/my-bets';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    selector: 'ms-my-bets-betslip-badges',
    template: `
        <div class="betslip-badges-container">
            <ms-my-bets-edited-badge *ngIf="isEditedBadgeVisible"></ms-my-bets-edited-badge>
            <ms-my-bets-auto-cashout-badge *ngIf="isAutoCashoutBadgeVisible"></ms-my-bets-auto-cashout-badge>
            <ms-my-bets-outcome-badge *ngIf="isOutcomeBadgeVisible" [betslip]="betslip"></ms-my-bets-outcome-badge>
        </div>
    `,
    standalone: false,
})
export class MyBetsBetSlipBadgesComponent {
    @Input() betslip: MyBetsBetSlip;
    @Input() myBetsListContext: MyBetsListContext;

    constructor() {}

    get isOutcomeBadgeVisible(): boolean {
        if (this.betslip.isRecoveringAfterEditBet || this.betslip.isCachedOut) {
            return true;
        }

        if (this.betslip.state === SlipState.Open || this.myBetsListContext.isEventView) {
            return false;
        }

        return this.myBetsListContext.listType === BetslipListType.Settled;
    }

    get isEditedBadgeVisible(): boolean {
        return this.betslip.isEditBet && this.myBetsListContext.isPrintView;
    }

    get isAutoCashoutBadgeVisible(): boolean {
        if (this.betslip.earlyPayoutInformation) {
            return this.betslip.earlyPayoutInformation.autoCashoutTriggered;
        } else {
            return false;
        }
    }
}
